import { ArrowRightIcon } from "lucide-react";
import Image from "next/image";

const TestimonialCard = ({ logo, desc, subHead, bgColor, image }) => {
  return (
    <>
      <section className="px-6 md:px-8 xl:px-28">
        <div className=" max-w-screen-xl mx-auto my-12 md:my-32 text-black md:rounded-2xl flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-2/3 mb-6 md:mb-0 md:pr-10">
            <Image src={logo} alt="Headout Logo" width={170} height={170} />

            <p className="text-2xl md:text-3xl font-bold mb-4 xl:mb-8 ">
              {desc}
            </p>

            <p className="mb-6 text-sm md:text-xl ">{subHead}</p>
            <div className="flex flex-col xl:gap-3 sm:flex-row sm:space-x-8 text-center sm:text-left hidden md:flex mt-10 xl:mt-32">
              <div className="mb-4 sm:mb-0 max-w-[30%]">
                <p className="text-5xl mb-2 text-indigo-600 font-semibold">
                  60%
                </p>
                <p className="">
                  Decrease in contract handling time for legal teams
                </p>
              </div>
              <div className="mb-4 sm:mb-0">
                <p className="text-5xl mb-2 text-indigo-600 font-semibold">
                  900+
                </p>
                <p className="">Digital agreements signed using BoloSign</p>
              </div>
              <div>
                <p className="text-5xl mb-2 text-indigo-600 font-semibold whitespace-nowrap">
                  1-2 days
                </p>
                <p className="">To fully onboard new partners</p>
              </div>
            </div>

            {/* CTA Button */}
            {/* <button className="md:mt-10 inline-flex items-center px-6 py-2 border border-white rounded-full font-medium hover:bg-white hover:text-[#001B66] transition">
              Read customer story
              <ArrowRightIcon className="w-6 h-6 ml-2" />
            </button> */}
          </div>

          <div className="w-full md:w-1/3">
            <Image
              src={image}
              alt="Customer discussion"
              width={500}
              height={500}
              className="w-full h-full"
            />
          </div>
          <div className="grid grid-cols-2 gap-5 md:hidden py-5">
            <div className="mb-4 sm:mb-0 md:max-w-[30%]">
              <p className="text-2xl md:text-5xl md:mb-2">60%</p>
              <p className="text-sm">
                Decrease in contract handling time for legal teams
              </p>
            </div>
            <div className="mb-4 sm:mb-0">
              <p className="text-2xl md:text-5xl md:mb-2">900+</p>
              <p className="text-sm">
                Digital agreements signed using BoloSign
              </p>
            </div>
            <div>
              <p className="text-2xl md:text-5xl md:mb-2">1-2 days</p>
              <p className="text-sm">To fully onboard new partners</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialCard;
